import { JOURNEY_ASSET_BASE_URL } from '../../config';
export const DOODLE_ROBOT_PWO_ID = 'wl.doodle_robot.assembly';
export const DOODLE_SCENES = Object.freeze([
  'mainmenu', 'attach_supports', 'connect_wires', 'mount_switch',
  'fit_motor_sleeve', 'mount_motor', 'mount_battery_holder',
  'attach_crank', 'attach_pens', 'first_test',
]);
export const FOOD_DELIVERY_ROBOT_PWO_ID = 'wonderlabs_food_delivery_robot_threejs';
export const FOOD_DELIVERY_SCENES = Object.freeze([
  "attach_cross_plate",
  "mount_first_L_bracket",
  "mount_blue_tray",
  "second_board_bracket",
  "join_second_board",
  "connect_motor_leads",
  "insert_wheel_pins",
  "attach_wheels_to_motor",
  "align_motor_with_board",
  "seat_motor_and_secure",
  "mount_battery_holder",
  "attach_eyes_finish",
  "power_switch_preflight"
]);
const THREEJS_PWOS = Object.freeze({
  [DOODLE_ROBOT_PWO_ID]: { kit: 'doodle-robot', scenes: DOODLE_SCENES },
  [FOOD_DELIVERY_ROBOT_PWO_ID]: { kit: 'food-delivery-robot', scenes: FOOD_DELIVERY_SCENES },
});
export const isThreeJsPwo = (id) => Object.prototype.hasOwnProperty.call(THREEJS_PWOS, String(id || ''));
export const isKnownThreeJsPwoScene = (id, name) => isThreeJsPwo(id) && THREEJS_PWOS[String(id)].scenes.includes(name);
export function buildThreeJsPwoUrl(pwoId, sceneName, parentOrigin) {
  if (!isKnownThreeJsPwoScene(pwoId, sceneName)) throw new Error('Unknown Three.js PWO or scene');
  const kit = THREEJS_PWOS[String(pwoId)].kit;
  const u = new URL(`${JOURNEY_ASSET_BASE_URL}/${kit}/pwo/index.html`, parentOrigin);
  u.searchParams.set('pwo_id', String(pwoId));
  u.searchParams.set('scene_name', sceneName);
  u.searchParams.set('embed', '1');
  u.searchParams.set('parent_origin', parentOrigin);
  return u.toString();
}
